import { Pricing } from '../contracts';

const getDecimalPlaces = (multiplier?: number) => {
  switch (multiplier) {
    case 1:
      return 0;
    case 100:
      return 2;
    case 1000:
      return 3;
    default:
      return 2;
  }
};

export function getPaymentRequestAmount(number?: number, pricing?: Pricing): string {
  if (number == null || Number.isNaN(number)) return '0.00';
  const value = pricing?.isCents && pricing?.multiplier ? number / pricing.multiplier : number;
  const decimalPlaces = getDecimalPlaces(pricing?.multiplier);
  return value.toFixed(decimalPlaces);
}
